import { useDisclosure } from "@chakra-ui/react";

import { useState } from "react";
import ModalCadastroPessoaUnidade from "components/Features/Unidades/components/ModalCadastroPessoaUnidade";

import ModalCadastroPessoaJuridicaUnidade from "components/Features/Unidades/components/ModalCadastroPessoaJuridicaUnidade";
import TabelaUnidadePessoas from "./components/TabelaUnidadePessoas";
import { PessoaTipo } from "core/features/pessoas/typings";

function TabPessoas({
  unidadeId,
  tenantId,
}: {
  unidadeId: string;
  tenantId: string;
}) {
  const [refreshDate, setRefreshDate] = useState<number | null>(null);
  const [changeProprietario, setChangeProprietario] = useState<boolean>(false);

  const {
    isOpen: isOpenPessoaFisicaModal,
    onToggle: onTogglePessoaFisicaModal,
  } = useDisclosure();

  const {
    isOpen: isOpenPessoaJuridicaModal,
    onToggle: onTogglePessoaJuridicaModal,
  } = useDisclosure();

  const [idEdit, setIdEdit] = useState<string | undefined>();

  const handleToggleOpenModal = (pessoaTipo: PessoaTipo) => {
    if (pessoaTipo === PessoaTipo.Juridica) {
      onTogglePessoaJuridicaModal();
    } else {
      onTogglePessoaFisicaModal();
    }
  };

  return (
    <>
      {isOpenPessoaFisicaModal ? (
        <ModalCadastroPessoaUnidade
          changeProprietario={changeProprietario}
          onSaved={() => {
            setIdEdit(undefined);
            onTogglePessoaFisicaModal();
            setRefreshDate(+new Date());
            setChangeProprietario(false);
          }}
          id={idEdit}
          isOpen={isOpenPessoaFisicaModal}
          onClose={() => {
            setIdEdit(undefined);
            setChangeProprietario(false);
            onTogglePessoaFisicaModal();
          }}
          unidadeId={unidadeId}
          tenantId={tenantId}
        />
      ) : null}

      {isOpenPessoaJuridicaModal ? (
        <ModalCadastroPessoaJuridicaUnidade
          onSaved={() => {
            setIdEdit(undefined);
            onTogglePessoaJuridicaModal();
            setRefreshDate(+new Date());
          }}
          id={idEdit}
          isOpen={isOpenPessoaJuridicaModal}
          onClose={() => {
            setIdEdit(undefined);
            onTogglePessoaJuridicaModal();
          }}
          unidadeId={unidadeId}
        />
      ) : null}

      <TabelaUnidadePessoas
        refreshDate={refreshDate}
        onCreate={(pessoaTipo) => {
          handleToggleOpenModal(pessoaTipo);
        }}
        unidadeId={unidadeId}
        onEdit={(id, pessoaTipo) => {
          setIdEdit(id);
          handleToggleOpenModal(pessoaTipo);
        }}
        onChangeProprietario={() => {
          handleToggleOpenModal(PessoaTipo.Fisica);
          setChangeProprietario(true);
        }}
      />
    </>
  );
}

export default TabPessoas;
